import React, { Component } from "react";
import { Redirect, Link } from "react-router-dom";
import { toastr } from "react-redux-toastr";
import { connect } from "react-redux";
import logo from "../../images/clean-your-lists-transparent-logo.png";
import "../../css/animate.min.css";
import "../../css/login.css";
import { forgotPasswordHandleChange } from "../../common/actions";
import { resetPasswordAction } from "../../Containers/Login/actions";

import Overlay from "../../utility/overlay";
import {
  resetPasswordValidators,
  updateValidators,
  initValidations
} from "../../utility/validations";

import { ValidationSummary } from "../../utility/ValidationSummary";
import { PASSWORD_MAX_LEN } from "../../utility/globalConstants";

const mapStateToProps = state => ({
  forgotPasswordInfo: state.forgotPasswordInfo
});

class ResetPassword extends Component {
  constructor() {
    super();

    this.state = { showErrorSummary: false };
    this.validators = resetPasswordValidators;

    initValidations(this.validators);

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  handleChange(event) {
    this.props.dispatch(
      forgotPasswordHandleChange(event.target.name, event.target.value)
    );
    updateValidators(
      this.validators,
      event.target.name,
      event.target.value,
      this.props.forgotPasswordInfo.password
    );
  }
  handleSubmit(event) {
    event.preventDefault();
    this.setState({ showErrorSummary: true });
    if (this.validators.errorSummary.length == 0) {
      if (
        this.props.forgotPasswordInfo.password != "" &&
        this.props.forgotPasswordInfo.password ==
          this.props.forgotPasswordInfo.confirmpassword
      ) {
        const {
          password,
          confirmpassword,
          reset_pwd_token
        } = this.props.forgotPasswordInfo;
        this.props.dispatch(
          resetPasswordAction({
            password,
            confirmpassword,
            reset_pwd_token
          })
        );
      } else {
        toastr.error(
          "Password mismatch",
          "New password and confirm passwords are not matched"
        );
      }
    }
  }

  componentDidMount() {
    const queryString = new URLSearchParams(this.props.location.search);

    const reset_pwd_token = queryString.get("reset_pwd_token");

    if (reset_pwd_token != undefined && reset_pwd_token.length > 0) {
      this.props.dispatch(
        forgotPasswordHandleChange("reset_pwd_token", reset_pwd_token)
      );
    } else {
      //navigationg to the Login page when no token available in Url
      this.props.history.push("/login");
    }
  }
  render() {
    return (
      <div className="login full-height">
        {this.state.showErrorSummary ? (
          <ValidationSummary errorMsg={this.validators.errorSummary} />
        ) : null}

        {this.props.forgotPasswordInfo.btnDisabled ? <Overlay /> : null}

        <div className="login_wrapper">
          <div className="animate form login_form">
            <div className="text-center">
              <h1>
                <img src={logo} alt="logo" width="200" />
              </h1>
            </div>
            <section className="login_content">
              <form style={{ marginBottom: 0 }} onSubmit={this.handleSubmit}>
                <h1> Reset Password </h1>
                <div className="form-label">
                  New Password
                  <span className="required-label">*</span> <br />
                  <input
                    type="password"
                    className="form-control"
                    name="password"
                    onChange={this.handleChange}
                    value={this.props.forgotPasswordInfo.password}
                    maxLength={PASSWORD_MAX_LEN}
                  />
                </div>
                <div className="form-label">
                  Confirm password
                  <span className="required-label">*</span> <br />
                  <input
                    type="password"
                    className="form-control"
                    name="confirmpassword"
                    onChange={this.handleChange}
                    value={this.props.forgotPasswordInfo.confirmpassword}
                    maxLength={PASSWORD_MAX_LEN}
                  />
                </div>

                <div className="col-md-6 text-left">
                  <button className="btn btn-default btn-primary">
                    Reset Password
                  </button>
                </div>

                <div className="clearfix" />

                <div className="separator">
                  <p className="change_link">
                    <Link to="/login" className="to_register">
                      {" "}
                      Go to Login page
                    </Link>
                  </p>
                </div>
              </form>
            </section>
          </div>
        </div>
      </div>
    );
  }
}
export default connect(mapStateToProps)(ResetPassword);



// WEBPACK FOOTER //
// ./src/components/Login/ResetPassword.js